<template>
  <v-dialog v-model="dialog" max-width="750" persistent>
    <v-card>
      <v-card-title class="title">
        {{ appointment.title }}
        <v-spacer />
        <v-btn icon small @click="closeDialog"
          ><v-icon small>mdi-close</v-icon></v-btn
        >
      </v-card-title>
      <v-stepper v-model="step" vertical>
        <v-stepper-step color="orange_popup" :complete="step > 1" step="1">
          <span class="body pt-1">{{ appointment.step_one.title }}</span>
          <small v-if="step === 1">{{
            appointment.step_one.description
          }}</small>
        </v-stepper-step>

        <v-stepper-content step="1" class="pb-2 pt-0">
          <v-card flat class="mb-3 mr-4">
            <v-row class="py-0">
              <v-col cols="12" sm="4">
                <v-select
                  v-model="step_one.exam"
                  :items="appointment.exam.items"
                  :label="appointment.exam.label"
                  :menu-props="{ offsetY: true }"
                  hide-details
                  color="orange_popup"
                  item-color="orange_popup"
                  class="field"
                >
                </v-select>
              </v-col>
              <v-col cols="12" sm="4">
                <v-menu
                  v-model="step_one.menu_date"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="computedDateFormatted"
                      :label="appointment.date.label"
                      hide-details
                      readonly
                      v-bind="attrs"
                      color="orange_popup"
                      class="field"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="step_one.date"
                    locale="pt-pt"
                    no-title
                    color="orange_popup"
                    :allowed-dates="allowedDates"
                    @input="menu2 = false"
                  >
                    ></v-date-picker
                  >
                </v-menu>
              </v-col>
              <v-col cols="12" sm="4">
                <v-select
                  v-if="step_one.date"
                  v-model="step_one.time"
                  :items="filteredTimeItems"
                  :label="appointment.time.label"
                  :menu-props="{ offsetY: true }"
                  hide-details
                  color="orange_popup"
                  item-color="orange_popup"
                  class="field"
                ></v-select>
              </v-col>
            </v-row>
          </v-card>
          <v-btn color="orange_popup" depressed dark @click="handleFirstForm">
            {{ appointment.step_one.next }}
          </v-btn>
        </v-stepper-content>

        <v-stepper-step color="orange_popup" :complete="step > 2" step="2">
          <span class="body pt-1">{{ appointment.step_two.title }}</span>
          <small v-if="step === 2">{{
            appointment.step_two.description
          }}</small>
        </v-stepper-step>

        <v-stepper-content step="2" class="pb-2 pt-0">
          <v-card flat class="mb-3 mr-4">
            <v-row class="py-0">
              <v-col cols="12">
                <v-text-field
                  v-model="step_two.name"
                  :label="appointment.name.label"
                  color="orange_popup"
                  class="field"
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="py-0">
              <v-col cols="12" sm="8">
                <v-text-field
                  v-model="step_two.email"
                  :label="appointment.email.label"
                  color="orange_popup"
                  class="field"
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field
                  v-model="step_two.phone"
                  :label="appointment.phone.label"
                  color="orange_popup"
                  class="field"
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card>
          <v-btn
            dark
            color="orange_popup"
            class="mr-2"
            depressed
            @click="handleSecondForm"
          >
            {{ appointment.step_two.next }}
          </v-btn>
          <v-btn text @click="step = 1">
            {{ appointment.step_two.previous }}
          </v-btn>
        </v-stepper-content>

        <v-stepper-step color="orange_popup" :complete="step > 3" step="3">
          <span class="body pt-1">{{ appointment.step_three.title }}</span>
          <small v-if="step === 3">{{
            appointment.step_three.description
          }}</small>
        </v-stepper-step>

        <v-stepper-content step="3" class="pb-2 pt-0">
          <v-card flat class="mb-3 mr-4">
            <v-row class="py-0">
              <v-col cols="12" sm="6">
                <div class="d-flex flex-column pt-3">
                  <span class="confirm-body">{{ appointment.exam.label }}</span>
                  <span class="confirm-field pt-0">{{ step_one.exam }}</span>
                </div>
                <div class="d-flex flex-column">
                  <span class="confirm-body">{{ appointment.date.label }}</span>
                  <span class="confirm-field pt-0">{{
                    computedDateFormatted
                  }}</span>
                </div>
                <div class="d-flex flex-column">
                  <span class="confirm-body">{{ appointment.time.label }}</span>
                  <span class="confirm-field pt-0">{{ step_one.time }}</span>
                </div>
              </v-col>
              <v-col cols="12" sm="6">
                <div class="d-flex flex-column pt-3">
                  <span class="confirm-body">{{ appointment.name.label }}</span>
                  <span class="confirm-field pt-0">{{ step_two.name }}</span>
                </div>
                <div class="d-flex flex-column">
                  <span class="confirm-body">{{
                    appointment.email.label
                  }}</span>
                  <span class="confirm-field pt-0">{{ step_two.email }}</span>
                </div>
                <div class="d-flex flex-column">
                  <span class="confirm-body">{{
                    appointment.phone.label
                  }}</span>
                  <span class="confirm-field pt-0">{{ step_two.phone }}</span>
                </div>
              </v-col>
            </v-row>
          </v-card>
          <v-btn
            dark
            color="orange_popup"
            class="mr-2"
            depressed
            @click="handleThirdForm"
          >
            {{ appointment.step_three.next }}
          </v-btn>
          <v-btn text @click="step = 2">
            {{ appointment.step_three.previous }}
          </v-btn>
        </v-stepper-content>
      </v-stepper>
    </v-card>
  </v-dialog>
</template>

<script>
import lang from "../../lang/pt.json";
import homeService from "../../services";

export default {
  name: "Appointment",

  props: {
    snackbar: {
      type: Object,
      required: true,
    },
  },

  data: () => ({
    appointment: lang.home.appointment,
    step: 1,
    step_one: {
      exam: undefined,
      date: undefined,
      time: undefined,
      menu_date: false,
    },
    step_two: {
      name: undefined,
      email: undefined,
      phone: undefined,
    },
    dialog: false,
  }),

  computed: {
    computedDateFormatted() {
      return this.formatDate(this.step_one.date);
    },
    filteredTimeItems() {
      if (
        (this.step_one.date && new Date(this.step_one.date).getDay() === 6) ||
        this.step_one.exam.startsWith("Análises clínicas")
      ) {
        return this.appointment.time.items.weekend;
      }
      return this.appointment.time.items.week;
    },
  },

  methods: {
    allowedDates(val) {
      if (new Date(val).getDay() === 0) return false;

      const today = new Date();
      const tomorrow = new Date(today);
      tomorrow.setDate(tomorrow.getDate() + 1);
      return val >= tomorrow.toISOString().substr(0, 10);
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    closeDialog() {
      this.dialog = false;
    },
    cleanDialog() {
      this.step = 1;
      this.step_one = {
        exam: undefined,
        date: undefined,
        time: undefined,
        menu_date: false,
      };
      this.step_two = {
        name: undefined,
        email: undefined,
        phone: undefined,
      };
    },
    openDialog() {
      this.dialog = true;
    },
    handleFirstForm() {
      if (!this.step_one.exam) {
        this.showError(this.appointment.exam.error);
        return;
      }
      if (!this.step_one.date) {
        this.showError(this.appointment.date.error);
        return;
      }
      if (!this.step_one.time) {
        this.showError(this.appointment.time.error);
        return;
      }

      this.step = 2;
    },
    handleSecondForm() {
      if (!this.step_two.name) {
        this.showError(this.appointment.name.error);
        return;
      }
      if (!this.step_two.email) {
        this.showError(this.appointment.email.error);
        return;
      }
      if (!this.step_two.phone) {
        this.showError(this.appointment.phone.error);
        return;
      }

      this.step = 3;
    },
    handleThirdForm() {
      homeService
        .postAppointment(
          this.step_one.exam,
          this.computedDateFormatted,
          this.step_one.time,
          this.step_two.name,
          this.step_two.email,
          this.step_two.phone,
        )
        .then(res => {
          if (res.status === 200) {
            this.snackbar.show = false;
            this.$nextTick(() => {
              this.snackbar.show = true;
              this.snackbar.text =
                "Foi realizado o pedido de agendamento. Deverá ser contactado em breve.";
              this.snackbar.color = "success";
              this.snackbar.timeout = 5000;
            });
            this.closeDialog();
            this.cleanDialog();
          } else {
            this.showError(
              "Ocurreu um erro a agendar o exame. Por favor entre em contacto por outra via.",
            );
          }
        })
        .catch(() => {
          this.showError(
            "Ocurreu um erro a agendar o exame. Por favor entre em contacto por outra via.",
          );
        });
    },
    showError(message) {
      this.snackbar.show = false;
      this.$nextTick(() => {
        this.snackbar.show = true;
        this.snackbar.text = message;
        this.snackbar.color = "error";
        this.snackbar.timeout = 5000;
      });
      return;
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/scss/variables.scss";

.title {
  color: map-get($theme-colors, "dark-blue") !important;
  font-family: nexa_bold;
  font-size: 24px;
  letter-spacing: 0;
  line-height: 24px;
}

.body {
  color: map-get($theme-colors, "dark-blue") !important;
  font-family: "Roboto" !important;
  font-size: 15px;
  letter-spacing: 0;
  line-height: 20px;
  text-overflow: unset;
  white-space: unset;
  -webkit-line-clamp: unset;
}

.confirm-body {
  color: map-get($theme-colors, "dark-blue") !important;
  font-family: nexa_bold !important;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 20px;
  text-overflow: unset;
  white-space: unset;
  -webkit-line-clamp: unset;
}

.confirm-field {
  color: map-get($theme-colors, "dark-blue") !important;
  font-family: "Roboto" !important;
  font-size: 12px;
  letter-spacing: 0;
  line-height: 20px;
  text-overflow: unset;
  white-space: unset;
  -webkit-line-clamp: unset;
}

.field {
  color: map-get($theme-colors, "dark-blue") !important;
  font-family: "Roboto" !important;
  font-size: 13px;
  letter-spacing: 0;
  line-height: 20px;
  text-overflow: unset;
  white-space: unset;
  -webkit-line-clamp: unset;
  padding-top: 10px;
}
</style>
